import { useMemo } from "react";
import { useHistory } from "react-router";
import dayjs from "dayjs";
import queryStringParser from "query-string";
import { IOfferAvailabilityRequest } from "redmond/hotels-module/interfaces";
import { LodgingCollectionEnum, PlatformEnum } from "redmond";

export const useOffersSearchParams = (): IOfferAvailabilityRequest => {
  const history = useHistory();

  const params = useMemo(() => {
    const queryParams = queryStringParser.parse(history.location.search);

    // Parse URL parameters with defaults (calculate defaults only when needed)
    const fromDate =
      typeof queryParams.fromDate === "string"
        ? queryParams.fromDate
        : dayjs().add(7, "days").format("YYYY-MM-DD");

    const untilDate =
      typeof queryParams.untilDate === "string"
        ? queryParams.untilDate
        : dayjs().add(11, "days").format("YYYY-MM-DD");

    const adultsCount =
      typeof queryParams.adultsCount === "string"
        ? parseInt(queryParams.adultsCount, 10) || 2
        : 2;

    // Parse children array from URL parameters
    const children = Array.isArray(queryParams.children)
      ? queryParams.children
          .map((age) => parseInt(String(age).trim(), 10))
          .filter((age) => !Number.isNaN(age))
      : [];

    return {
      stayDates: {
        from: fromDate,
        until: untilDate,
      },
      guests: {
        adults: adultsCount,
        children,
      },
      rooms: {
        numberOfRooms: 1,
      },
      platform: PlatformEnum.Desktop,
      lodgingCollection: LodgingCollectionEnum.Premier,
    };
  }, [history.location.search]);

  return params;
};
